import { useEffect, useState } from "react";
import {
  CHECK_CALLBACK_STATUS,
  FETCH_ONBOARD_MERCHANT_DETAILS,
  FETCH_PAYMENT_SERVICES_PHASE1_API,
  UPDATE_BANK_DETAILS_STAGE2,
  UPDATE_ONBOARD_MERCHANT_DETAILS,
} from "../../../utils/constant";
import swal from "sweetalert";
import {
  getKeyPressed,
  isIfscRegexIsValid,
  isWebsiteURLRegexIsValid,
  stopNumberCharInput,
  stopSpecialCharacterInput,
} from "../../../utils/helper";
import { useSelector } from "react-redux";
import useApiServices from "../../../utils/useApiServices";
import RemoveIcon from "@mui/icons-material/Remove";
import VerifiedIcon from "@mui/icons-material/Verified";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import SelectField from "../../common/SelectField";
import { ToolsActionRegistry } from "../../../Privillages/ActionRegistry";
import useHasPrivilege from "../../../Privillages/useHasPrivilege";

function OpenDetails({ mid, handleClose }) {
  const { SECTION_KEY, MERHCANT_DETAIL_EDIT } = ToolsActionRegistry;
  const hasMerchantEdit = useHasPrivilege(SECTION_KEY, MERHCANT_DETAIL_EDIT);
  const [merchantData, setmerchantData] = useState([]);
  const [getAgain, setGetAgain] = useState(false);
  const [again, setAgain] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [updatedDetails, setUpdatedDetails] = useState({ ...merchantData });
  const [payoutActiveFor, setPayoutActiveFor] = useState("");
  const [isPhase2Editing, setIsPhase2Editing] = useState(false);
  const [showPaymentServicesList, setShowPaymentServicesList] = useState(false);
  const [pressedKeyName, setPressedKeyName] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [paymentservice, setServices] = useState([]);
  const [phase2Details, setPhase2Details] = useState({ ...merchantData });
  const [payinCallbackStatus, setPayinCallbackStatus] = useState(false);
  const [chargebackCallbackStatus, setChargebackCallbackStatus] =
    useState(false);
  const [payoutCallbackStatus, setPayoutCallbackStatus] = useState(false);
  const { apiCallFnforGet, apiCallFnforPut, apiCallFnforPost } =
    useApiServices();

  useEffect(() => {
    fetchmerchantDetails(mid);
  }, [getAgain, again, mid]);
  const { prefix } = useSelector((state) => state.userPrivileges);

  const fetchmerchantDetails = async (mid) => {
    try {
      const response = await apiCallFnforGet(
        FETCH_ONBOARD_MERCHANT_DETAILS + mid
      );

      if (response.statusCode === 200) {
        setmerchantData(response?.data);
        const uniqueServices = Array.from(
          new Set(
            response?.data?.paymentService?.map(
              (service) => service.paymentService
            )
          )
        );
        setSelectedServices(uniqueServices);
        setPayoutActiveFor(response?.data?.payoutActiveFor);
      } else if (response.statusCode === 304) {
        swal({
          title: "Failed",
          text: "Merchant not on-Boarded",
          icon: "error",
        });
        setPayoutActiveFor("");
      } else {
        swal({
          title: "Failed",
          text: response.message,
          icon: "error",
        });
        setPayoutActiveFor("");
      }
    } catch (error) {
      setUpdatedDetails({
        ...updatedDetails,
        payoutActiveFor: "",
      });
      console.error("Error fetching merchant details:", error);
    }
  };

  useEffect(() => {
    apiCallFnforGet(FETCH_PAYMENT_SERVICES_PHASE1_API)
      .then((response) => {
        setServices(response?.data);
      })
      .catch((error) => {
        console.error("Error fetching payment services:", error.message);
      });
  }, []);

  const handleServiceChange = (serviceValue) => {
    const found = selectedServices?.find((item) => item === serviceValue);
    if (found) {
      setSelectedServices(selectedServices?.filter((item) => item !== found));
    } else {
      setSelectedServices([...selectedServices, serviceValue]);
    }
  };
  const toggleEditing = () => {
    if (!isEditing) {
      const paymentTypeIds = selectedServices
        ?.map((service) => {
          const foundService = paymentservice?.find(
            (item) => item.paymentService === service
          );
          return foundService ? foundService.paymentTypeId : null;
        })
        .filter((id) => id !== null);

      const updatedDetailsCopy = { ...updatedDetails };
      updatedDetailsCopy.paymentTypeId = paymentTypeIds;
      setUpdatedDetails({
        authorizedPersonName: merchantData.authorizedPersonName,
        aapUrl: merchantData.aapUrl,
        businessTypeName: merchantData.businessTypeName,
        businessAs: merchantData.businessAs,
        commissionPercentage: 0,
        communicationAddress: merchantData.communicationAddress,
        communicationAddressAreaName: merchantData.communicationAddressAreaName,
        communicationAddressCity: merchantData.communicationAddressCity,
        communicationAddressPinCode: merchantData.communicationAddressPinCode,
        communicationAddressState: merchantData.communicationAddressState,
        companyAddress: merchantData.companyAddress,
        companyAddressAreaName: merchantData.companyAddressAreaName,
        companyAddressCity: merchantData.companyAddressCity,
        companyAddressPinCode: merchantData.companyAddressPinCode,
        companyAddressState: merchantData.companyAddressState,
        email: merchantData.email,
        mobile: merchantData.mobile,
        newCompanyAddress: merchantData.newCompanyAddress,
        registeredOfficeAddress: merchantData.registeredOfficeAddress,
        registeredOfficeAddressAreaName:
          merchantData.registeredOfficeAddressAreaName,
        registeredOfficeAddressCity: merchantData.registeredOfficeAddressCity,
        registeredOfficeAddressPinCode:
          merchantData.registeredOfficeAddressPinCode,
        registeredOfficeAddressState: merchantData.registeredOfficeAddressState,
        registrationId: merchantData.registrationId,
        websiteUrl: merchantData.websiteUrl,
        paymentTypeId: paymentTypeIds,
      });
      setPayoutActiveFor(merchantData?.payoutActiveFor);
    }
    setIsEditing(!isEditing);
    setIsPhase2Editing(false);
  };

  const handleSave = async () => {
    if (selectedServices?.includes("PAYOUT") && !payoutActiveFor) {
      swal("Error", "Please select Payout Active For before saving.", "error");
      return;
    }
    if (
      updatedDetails.authorizedPersonName === "" ||
      phase2Details.authorizedPersonName === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter authorised person name !",
        icon: "error",
      });
      return;
    }
    if (updatedDetails.mobile === "" || phase2Details.mobile === null) {
      swal({
        title: "Alert!",
        text: "Please enter mobile number !",
        icon: "error",
      });
      return;
    }
    if (
      merchantData.businessType?.toLowerCase() === "others" &&
      !updatedDetails.businessTypeName?.trim()
    ) {
      swal({
        title: "Alert!",
        text: "Please enter other business category !",
        icon: "error",
      });
      return;
    }
    if (updatedDetails.email === "" || phase2Details.email === null) {
      swal({
        title: "Alert!",
        text: "Please enter email ID !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.companyAddress === "" ||
      phase2Details.companyAddress === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company registered address !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.companyAddressPinCode === "" ||
      phase2Details.companyAddressPinCode === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company registered pin-code !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.companyAddressCity === "" ||
      phase2Details.companyAddressCity === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company registered city !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.companyAddressState === "" ||
      phase2Details.companyAddressState === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company registered state !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.registeredOfficeAddress === "" ||
      phase2Details.registeredOfficeAddress === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter authorized signatory address !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.registeredOfficeAddressPinCode === "" ||
      phase2Details.registeredOfficeAddressPinCode === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter authorized signatory pincode !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.registeredOfficeAddressCity === "" ||
      phase2Details.registeredOfficeAddressCity === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter authorized signatory city !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.registeredOfficeAddressState === "" ||
      phase2Details.registeredOfficeAddressState === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter authorized signatory state !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.communicationAddress === "" ||
      phase2Details.communicationAddress === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company communication address !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.communicationAddressPinCode === "" ||
      phase2Details.communicationAddressPinCode === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company communication pin code !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.communicationAddressCity === "" ||
      phase2Details.communicationAddressCity === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company communication city !",
        icon: "error",
      });
      return;
    }
    if (
      updatedDetails.communicationAddressState === "" ||
      phase2Details.communicationAddressState === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter company communication state !",
        icon: "error",
      });
      return;
    }

    try {
      const paymentTypeIds = selectedServices?.map((service) => {
        const foundService = paymentservice?.find(
          (item) => item.paymentService === service
        );
        return foundService.paymentTypeId;
      });

      const updatedDetailsCopy = { ...updatedDetails };
      updatedDetailsCopy.paymentTypeId = paymentTypeIds;

      const payload = {
        authorizedPersonName: updatedDetails.authorizedPersonName,
        aapUrl: updatedDetails.aapUrl,
        businessTypeName: updatedDetails.businessTypeName,
        businessAs: updatedDetails.businessAs,
        commissionPercentage: 0,
        communicationAddress: updatedDetails.communicationAddress,
        communicationAddressAreaName:
          updatedDetails.communicationAddressAreaName,
        communicationAddressCity: updatedDetails.communicationAddressCity,
        communicationAddressPinCode: updatedDetails.communicationAddressPinCode,
        communicationAddressState: updatedDetails.communicationAddressState,
        companyAddress: updatedDetails.companyAddress,
        companyAddressAreaName: updatedDetails.companyAddressAreaName,
        companyAddressCity: updatedDetails.companyAddressCity,
        companyAddressPinCode: updatedDetails.companyAddressPinCode,
        companyAddressState: updatedDetails.companyAddressState,
        email: updatedDetails.email,
        mobile: updatedDetails.mobile,
        newCompanyAddress: updatedDetails.newCompanyAddress,
        registeredOfficeAddress: updatedDetails.registeredOfficeAddress,
        registeredOfficeAddressAreaName:
          updatedDetails.registeredOfficeAddressAreaName,
        registeredOfficeAddressCity: updatedDetails.registeredOfficeAddressCity,
        registeredOfficeAddressPinCode:
          updatedDetails.registeredOfficeAddressPinCode,
        registeredOfficeAddressState:
          updatedDetails.registeredOfficeAddressState,
        registrationId: updatedDetails.registrationId,
        websiteUrl: updatedDetails.websiteUrl,
        paymentTypeId: paymentTypeIds,
        payoutActiveFor: payoutActiveFor,
      };

      const response = await apiCallFnforPut(
        UPDATE_ONBOARD_MERCHANT_DETAILS,
        payload
      );

      if (response.statusCode === 200) {
        setmerchantData(updatedDetails);
        toggleEditing();
        swal({
          title: "Success",
          text: "Profile updated successfully",
          icon: "success",
        });
        setGetAgain(!getAgain);
      } else {
        // console.error("API response error:", response.data);
        swal({
          title: "Failed",
          text: "Profile updation failed",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error updating merchant details:", error);
    }
  };

  const togglePhase2Editing = () => {
    if (!isPhase2Editing) {
      setPhase2Details({
        websiteUrl: merchantData.websiteUrl,
        mid: merchantData.mid,
        merchantIfscCode: merchantData.merchantIfscCode,
        merchantBankName: merchantData.merchantBankName,
        merchantAccountNumber: merchantData.merchantAccountNumber,
        callBackUrl: merchantData.callBackUrl,
        bankCity: 0,
        bankBranchName: merchantData.bankBranchName,
        accoutBeneficiaryName: merchantData.companyName,
        chargebackCallbackUrl: merchantData.chargebackCallbackUrl,
        payoutCallbackUrl: merchantData.payoutCallbackUrl,
      });
    }

    setIsPhase2Editing(!isPhase2Editing);
    setIsEditing(false);
  };

  const checkPhase2Validation = (name, e) => {
    if (
      (stopNumberCharInput(pressedKeyName) ||
        stopSpecialCharacterInput(pressedKeyName)) &&
      (name === "accoutBeneficiaryName" ||
        name === "bankBranchName" ||
        name === "merchantBankName")
    )
      return;

    setPhase2Details({
      ...phase2Details,
      [name]: e.target.value,
    });
  };

  const handelValidations = (e) => {
    if (e.target.name === "merchantIfscCode" && e.target.value !== "") {
      if (!isIfscRegexIsValid(phase2Details.merchantIfscCode)) {
        swal({
          title: "Alert!",
          text: "Please Enter Valid IFSC Code !",
          icon: "error",
        }).then(() => {
          setPhase2Details({ ...phase2Details, merchantIfscCode: "" });
        });
        return;
      }
    }

    if (e.target.name === "websiteUrl" && e.target.value !== "") {
      if (!isWebsiteURLRegexIsValid(phase2Details.websiteUrl)) {
        swal({
          title: "Alert!",
          text: "Please Enter Valid Website URL!",
          icon: "error",
        }).then(() => {
          setPhase2Details({ ...phase2Details, websiteUrl: "" });
        });
        return;
      }
    }
  };

  const ShowAlert = () => {
    swal({
      title: "Alert!",
      text: "Merchant not onboarded.",
      icon: "error",
    });
  };
  const handlePhase2Save = async () => {
    if (
      phase2Details.accoutBeneficiaryName === "" ||
      phase2Details.accoutBeneficiaryName === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter account beneficiary name !",
        icon: "error",
      });
      return;
    }

    if (
      phase2Details.bankBranchName === "" ||
      phase2Details.bankBranchName === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter bank branch name !",
        icon: "error",
      });
      return;
    }

    // if (
    //   phase2Details.callBackUrl === "" ||
    //   phase2Details.callBackUrl === null
    // ) {
    //   swal({
    //     title: "Alert!",
    //     text: "Please enter callBack URL !",
    //     icon: "error",
    //   });
    //   return;
    // }
    // if (
    //   phase2Details.payoutCallbackUrl === "" ||
    //   phase2Details.payoutCallbackUrl === null
    // ) {
    //   swal({
    //     title: "Alert!",
    //     text: "Please enter Payout callBack URL !",
    //     icon: "error",
    //   });
    //   return;
    // }
    // if (
    //   phase2Details.chargebackCallbackUrl === "" ||
    //   phase2Details.chargebackCallbackUrl === null
    // ) {
    //   swal({
    //     title: "Alert!",
    //     text: "Please enter Chargeback callBack URL !",
    //     icon: "error",
    //   });
    //   return;
    // }
    if (
      phase2Details.merchantAccountNumber === "" ||
      phase2Details.merchantAccountNumber === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter merchant account number !",
        icon: "error",
      });
      return;
    }

    if (
      phase2Details.merchantBankName === "" ||
      phase2Details.merchantBankName === null
    ) {
      swal({
        title: "Alert!",
        text: "Please Enter Merchant Bank Name !",
        icon: "error",
      });
      return;
    }

    if (
      phase2Details.merchantIfscCode === "" ||
      phase2Details.merchantIfscCode === null
    ) {
      swal({
        title: "Alert!",
        text: "Please enter IFSC code !",
        icon: "error",
      });
      return;
    }

    if (!isIfscRegexIsValid(phase2Details.merchantIfscCode)) {
      swal({
        title: "Alert!",
        text: "Please enter valid IFSC code !",
        icon: "error",
      }).then(() => {
        setPhase2Details({ ...phase2Details, merchantIfscCode: "" });
      });
      return;
    }

    try {
      const response = await apiCallFnforPut(
        UPDATE_BANK_DETAILS_STAGE2,
        phase2Details
      );

      if (response.statusCode === 200) {
        setmerchantData(phase2Details);

        togglePhase2Editing();
        swal({
          title: "Success",
          text: "Profile updated successfully",
          icon: "success",
        });
        setAgain(!again);
      } else {
        swal({
          title: "Faliure",
          text: "Profile not updated!",
          icon: "error",
        });
        console.error("API response error:", response.data);
      }
    } catch (error) {
      swal({
        title: "Faliure",
        text: error,
        icon: "error",
      });
      console.error("Error updating merchant details:", error);
    }
  };

  const handleVerifyUrl = async (url, type) => {
    try {
      const response = await apiCallFnforPost(CHECK_CALLBACK_STATUS, {
        url: url,
      });
      console.log(response);
      if (type === "payin") {
        setPayinCallbackStatus(response);
        setPhase2Details({
          ...phase2Details,
          callBackUrlStatus: response ? response : false,
        });
      } else if (type === "chargeback") {
        setChargebackCallbackStatus(response);
        setPhase2Details({
          ...phase2Details,
          chargebackCallbackUrlStatus: response ? response : false,
        });
      } else if (type === "payout") {
        setPayoutCallbackStatus(response);
        setPhase2Details({
          ...phase2Details,
          payoutCallbackUrlStatus: response ? response : false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <>
        <div className="">
          <div className="">
            {isEditing || isPhase2Editing ? (
              ""
            ) : (
              <div className="">
                <div className="">
                  <div className="">
                    <div className="">
                      <div className="table-responsive">
                        <div className="table table-bordered">
                          <div className="row">
                            {[
                              {
                                label: "User Name",
                                value: merchantData.userName,
                              },
                              {
                                label: "Master Merchant",
                                value: merchantData.masterMerchant,
                              },
                              {
                                label: "MCC Code",
                                value: merchantData.mccCode,
                              },
                              {
                                label: "Password",
                                value:
                                  prefix === "ALL"
                                    ? merchantData.password
                                    : "XXXXXXXXX",
                              },
                              {
                                label: "Payin Encryption Key",
                                value: merchantData.encKey,
                              },
                              {
                                label: "Payout API Key",
                                value: merchantData.apiKey,
                              },
                              {
                                label: "Payout Secret Key",
                                value: merchantData.secretKey,
                              },
                              { label: "MID", value: merchantData.mid },
                              {
                                label: "Company Name",
                                value: merchantData.companyName,
                              },
                              {
                                label: "Mobile Number",
                                value: merchantData.mobile,
                              },
                              {
                                label: "Business Type",
                                value: merchantData.companyType,
                              },
                              {
                                label: "Payment Services",
                                value: Array.from(
                                  new Set(
                                    merchantData?.paymentService?.map(
                                      (service) => service.paymentService
                                    )
                                  )
                                )
                                  .map((service) => `• ${service}`)
                                  .join(" "),
                              },
                              {
                                label: "Company PAN Number",
                                value: merchantData.companyPanNumber,
                              },
                              {
                                label: "GST Number",
                                value: merchantData.gstNumber,
                              },
                              {
                                label: "Authorized Person PAN",
                                value: merchantData.authorizedPersonPan,
                              },
                              {
                                label: "Aadhaar Number",
                                value: merchantData.aadharNumber,
                              },
                              {
                                label: "Mode of Registration",
                                value: merchantData.modeOfRegistration,
                              },
                              {
                                label: "Modification Date",
                                value: merchantData.modificationDate,
                              },
                              {
                                label: "Registration Type",
                                value: merchantData.registrationType,
                              },
                              {
                                label: "Business As",
                                value: merchantData.businessAs,
                              },
                              {
                                label: "Authorized Person Name",
                                value: merchantData.authorizedPersonName,
                              },
                              { label: "E-mail", value: merchantData.email },
                              {
                                label: "Website URL",
                                value: merchantData.websiteUrl,
                              },
                              {
                                label: "Application URL",
                                value: merchantData.aapUrl,
                              },
                              {
                                label: "Company Registered Address",
                                value: merchantData.companyAddress,
                              },
                              {
                                label: "Pin-Code",
                                value: merchantData.companyAddressPinCode,
                              },
                              {
                                label: "City",
                                value: merchantData.companyAddressCity,
                              },
                              {
                                label: "State",
                                value: merchantData.communicationAddressState,
                              },
                              {
                                label: "Account Beneficiary Name",
                                value: merchantData.companyName,
                              },
                              {
                                label: "Bank Branch Name",
                                value: merchantData.bankBranchName,
                              },
                              {
                                label: "Merchant Account Number",
                                value: merchantData.merchantAccountNumber,
                              },
                              {
                                label: "Merchant Bank Name",
                                value: merchantData.merchantBankName,
                              },
                              {
                                label: "Merchant IFSC Code",
                                value: merchantData.merchantIfscCode,
                              },
                              {
                                label: "Payin Callback URL",
                                value: merchantData?.callBackUrlStatus ? (
                                  <>
                                    <span>{merchantData?.callBackUrl}</span>
                                    <VerifiedIcon className="fs-4 text-success" />
                                    <span
                                      style={{ fontSize: "12px" }}
                                      className="text-success"
                                    >
                                      Verified
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <div>{merchantData?.callBackUrl}</div>
                                    <NewReleasesIcon
                                      style={{ cursor: "pointer" }}
                                      className="fs-5 text-danger"
                                    />
                                    <span
                                      style={{ fontSize: "12px" }}
                                      className="text-danger"
                                    >
                                      {" "}
                                      Not Verified
                                    </span>
                                  </>
                                ),
                              },
                              {
                                label: "Payout Callback URL",
                                value: merchantData?.payoutCallbackUrlStatus ? (
                                  <>
                                    <span>
                                      {merchantData?.payoutCallbackUrl}
                                    </span>
                                    <VerifiedIcon className="fs-4 text-success" />
                                    <span
                                      style={{ fontSize: "12px" }}
                                      className="text-success"
                                    >
                                      Verified
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <div>{merchantData?.payoutCallbackUrl}</div>
                                    <NewReleasesIcon
                                      style={{ cursor: "pointer" }}
                                      className="fs-5 text-danger"
                                    />
                                    <span
                                      style={{ fontSize: "12px" }}
                                      className="text-danger"
                                    >
                                      {" "}
                                      Not Verified
                                    </span>
                                  </>
                                ),
                              },
                              {
                                label: "Chargeback Callback URL",
                                value:
                                  merchantData?.chargebackCallbackUrlStatus ? (
                                    <>
                                      <span>
                                        {merchantData?.chargebackCallbackUrl}
                                      </span>
                                      <VerifiedIcon className="fs-4 text-success" />
                                      <span
                                        style={{ fontSize: "12px" }}
                                        className="text-success"
                                      >
                                        Verified
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <div>
                                        {merchantData?.chargebackCallbackUrl}
                                      </div>
                                      <NewReleasesIcon
                                        style={{ cursor: "pointer" }}
                                        className="fs-5 text-danger"
                                      />
                                      <span
                                        style={{ fontSize: "12px" }}
                                        className="text-danger"
                                      >
                                        {" "}
                                        Not Verified
                                      </span>
                                    </>
                                  ),
                              },
                              {
                                label: "Submission Date",
                                value: merchantData.submitDate,
                              },
                              {
                                label: "Submission Time",
                                value: merchantData.submitTime,
                              },
                              {
                                label: "Referred By",
                                value: merchantData.referredBy,
                              },
                            ].map((item, index) => (
                              <div
                                key={index}
                                className="col-6 border border-dark "
                                style={{
                                  borderRight: "0.5px solid black",
                                  borderLeft: "0.5px solid black",
                                  paddingBottom: "0px",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center table table-bordered">
                                  <tr className="fw-bold mt-2 w-100 d-flex justify-content-between align-items-center">
                                    {item.label} <RemoveIcon />
                                  </tr>{" "}
                                  <tr className="mt-2 w-100 text-end">
                                    {item.value}
                                  </tr>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* second table */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isEditing && !isPhase2Editing && (
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="table-sm right-border">
                      <thead>
                        <div className="d-flex justify-content-between fs-4 border-bottom mb-4 fw-bold">
                          <div>Label</div>
                          <div>Value</div>
                        </div>
                      </thead>
                      <tbody>
                        {[
                          {
                            label: "Business Category",
                            value: merchantData.businessType,
                          },
                          {
                            label: "Other Business Category",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.businessTypeName}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    businessTypeName: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.businessTypeName
                            ),
                          },
                          {
                            label: "Business As",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.businessAs}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    businessAs: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.businessAs
                            ),
                          },
                          {
                            label: "Authorized Person Name",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.authorizedPersonName}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    authorizedPersonName: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.authorizedPersonName
                            ),
                          },
                          {
                            label: "e-Mail ID",
                            value: isEditing ? (
                              <input
                                type="email"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.email}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    email: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.email
                            ),
                          },
                          {
                            label: "Mobile Number",
                            value: isEditing ? (
                              <input
                                type="tel"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.mobile}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    mobile: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.mobile
                            ),
                          },
                          {
                            label: "Website URL",
                            value: isEditing ? (
                              <input
                                type="url"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.websiteUrl}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    websiteUrl: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.websiteUrl
                            ),
                          },
                          {
                            label: "Application URL",
                            value: isEditing ? (
                              <input
                                type="url"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.aapUrl}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    aapUrl: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.aapUrl
                            ),
                          },
                          {
                            label: "Company Registered Address",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.companyAddress}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    companyAddress: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.companyAddress
                            ),
                          },
                          {
                            label: "Pin Code",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2 mx-3"
                                value={updatedDetails.companyAddressPinCode}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    companyAddressPinCode: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.companyAddressPinCode
                            ),
                          },
                        ].map((item, index) => (
                          <tr key={index} className="col-6">
                            <div className="d-flex justify-content-between align-items-center  gap-4">
                              <strong className="mt-4 form-label">
                                {item.label}
                              </strong>
                              <div className="col-6 border-none">
                                {item.value}
                              </div>
                            </div>
                          </tr>
                        ))}
                      </tbody>
                    </div>
                  </div>
                  <div className="col">
                    <table className="table-sm">
                      <thead>
                        <div className="d-flex justify-content-between  fs-4 mb-4 fw-bold border-bottom">
                          <div>Label</div>
                          <div>Value</div>
                        </div>
                      </thead>
                      <tbody>
                        {[
                          {
                            label: "City",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={updatedDetails.companyAddressCity}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    companyAddressCity: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.companyAddressCity
                            ),
                          },
                          {
                            label: "State",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={updatedDetails.companyAddressState}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    companyAddressState: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.companyAddressState
                            ),
                          },
                          {
                            label: "Authorized Signatory Address",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={updatedDetails.registeredOfficeAddress}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    registeredOfficeAddress: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.registeredOfficeAddress
                            ),
                          },
                          {
                            label: "Pin Code",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={
                                  updatedDetails.registeredOfficeAddressPinCode
                                }
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    registeredOfficeAddressPinCode:
                                      e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.registeredOfficeAddressPinCode
                            ),
                          },
                          {
                            label: "City",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={
                                  updatedDetails.registeredOfficeAddressCity
                                }
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    registeredOfficeAddressCity: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.registeredOfficeAddressCity
                            ),
                          },
                          {
                            label: "State",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={
                                  updatedDetails.registeredOfficeAddressState
                                }
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    registeredOfficeAddressState:
                                      e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.registeredOfficeAddressState
                            ),
                          },
                          {
                            label: "Company Communication Address",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={updatedDetails.communicationAddress}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    communicationAddress: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.communicationAddress
                            ),
                          },
                          {
                            label: "Pin Code",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={
                                  updatedDetails.communicationAddressPinCode
                                }
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    communicationAddressPinCode: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.communicationAddressPinCode
                            ),
                          },
                          {
                            label: "City",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={updatedDetails.communicationAddressCity}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    communicationAddressCity: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.communicationAddressCity
                            ),
                          },
                          {
                            label: "State",
                            value: isEditing ? (
                              <input
                                type="text"
                                className="form-control mb-2"
                                value={updatedDetails.communicationAddressState}
                                onChange={(e) =>
                                  setUpdatedDetails({
                                    ...updatedDetails,
                                    communicationAddressState: e.target.value,
                                  })
                                }
                              />
                            ) : (
                              merchantData.communicationAddressState
                            ),
                          },
                        ].map((item, index) => (
                          <tr key={index} className="col-6">
                            <div className="d-flex justify-content-between gap-4">
                              <strong className="mt-4 form-label">
                                {item.label}
                              </strong>
                              <div>{item.value}</div>
                            </div>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="mt-4">
                  {/* Toggle Button */}
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      setShowPaymentServicesList(!showPaymentServicesList)
                    }
                  >
                    {showPaymentServicesList
                      ? "Hide Services"
                      : "View Services"}
                  </button>

                  {/* Services List */}
                  {showPaymentServicesList && (
                    <>
                      <div className="row mt-3">
                        {paymentservice?.map((service) => (
                          <div
                            className="col-6 d-flex align-items-center mb-2"
                            key={service?.paymentTypeId}
                          >
                            <label className="form-check-label d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                value={service?.paymentService}
                                checked={
                                  selectedServices?.includes(
                                    service?.paymentService
                                  ) ?? false
                                }
                                onChange={() =>
                                  handleServiceChange(service?.paymentService)
                                }
                              />
                              {service?.paymentService}
                            </label>
                          </div>
                        ))}
                      </div>

                      {selectedServices?.length > 0 &&
                        selectedServices?.includes("PAYOUT") && (
                          <div className="mt-2">
                            <div className="col-5 d-flex align-items-center px-3 ">
                              <label htmlFor="email">Payout Active For</label>
                            </div>
                            <div className="col-7">
                              <SelectField
                                name="usedFor"
                                value={payoutActiveFor}
                                onChange={(e) => {
                                  setPayoutActiveFor(e?.target?.value);
                                }}
                                options={[
                                  { value: "PANEL", label: "PANEL" },
                                  { value: "API", label: "API" },
                                  { value: "BOTH", label: "BOTH" },
                                ]}
                              />
                            </div>
                          </div>
                        )}
                    </>
                  )}
                </div>
              </div>
            )}
            {isPhase2Editing && (
              <div className="">
                <div className="row">
                  <div className="col-6 ">
                    <div className="table-sm right-border">
                      <table className="table">
                        <thead>
                          <div className="fw-bold fs-4 border-bottom d-flex justify-content-between ">
                            <div>Label</div>
                            <div>Value</div>
                          </div>
                        </thead>
                        <tbody>
                          {[
                            {
                              label: "Account Beneficiary Name",
                              value: isPhase2Editing ? (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={phase2Details.accoutBeneficiaryName}
                                  onKeyDown={(e) => {
                                    setPressedKeyName(getKeyPressed(e));
                                  }}
                                  onChange={(e) =>
                                    checkPhase2Validation(
                                      "accoutBeneficiaryName",
                                      e
                                    )
                                  }
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.accoutBeneficiaryName}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Bank Branch Name",
                              value: isPhase2Editing ? (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={phase2Details.bankBranchName}
                                  onKeyDown={(e) => {
                                    setPressedKeyName(getKeyPressed(e));
                                  }}
                                  onChange={(e) =>
                                    checkPhase2Validation("bankBranchName", e)
                                  }
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.bankBranchName}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Payin Callback URL",
                              value: isPhase2Editing ? (
                                <div className="form-group">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control p-3 text-center"
                                      value={phase2Details.callBackUrl}
                                      onChange={(e) =>
                                        setPhase2Details({
                                          ...phase2Details,
                                          callBackUrl: e.target.value,
                                        })
                                      }
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      id="verifyButton"
                                      onClick={() =>
                                        handleVerifyUrl(
                                          phase2Details.callBackUrl,
                                          "payin"
                                        )
                                      }
                                    >
                                      Verify
                                    </button>
                                  </div>
                                  <div className="d-flex justify-content-start">
                                    {payinCallbackStatus ? (
                                      <span
                                        id="callBackUrlErr"
                                        className="text-success"
                                      >
                                        <VerifiedIcon className="fs-4" />{" "}
                                        Verified
                                      </span>
                                    ) : (
                                      <span
                                        id="callBackUrlErr"
                                        className="text-danger"
                                      >
                                        <NewReleasesIcon className="fs-4" /> Not
                                        Verified
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                // <input
                                //   type="text"
                                //   className="form-control p-3 text-center bg-success mb-2"
                                //   value={phase2Details.callBackUrl}
                                //   onChange={(e) =>
                                //     setPhase2Details({
                                //       ...phase2Details,
                                //       callBackUrl: e.target.value,
                                //     })
                                //   }
                                // />
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.callBackUrl}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Payout Callback URL",
                              value: isPhase2Editing ? (
                                <div className="form-group">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control p-3 text-center"
                                      value={phase2Details.payoutCallbackUrl}
                                      onChange={(e) =>
                                        setPhase2Details({
                                          ...phase2Details,
                                          payoutCallbackUrl: e.target.value,
                                        })
                                      }
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      id="verifyButton"
                                      onClick={() =>
                                        handleVerifyUrl(
                                          phase2Details.payoutCallbackUrl,
                                          "payout"
                                        )
                                      }
                                    >
                                      Verify
                                    </button>
                                  </div>
                                  <div className="d-flex justify-content-start">
                                    {payoutCallbackStatus ? (
                                      <span
                                        id="callBackUrlErr"
                                        className="text-success"
                                      >
                                        <VerifiedIcon className="fs-4" />{" "}
                                        Verified
                                      </span>
                                    ) : (
                                      <span
                                        id="callBackUrlErr"
                                        className="text-danger"
                                      >
                                        <NewReleasesIcon className="fs-4" /> Not
                                        Verified
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                // <input
                                //   type="text"
                                //   className="form-control p-3 text-center mb-2"
                                //   value={phase2Details.payoutCallbackUrl}
                                //   onChange={(e) =>
                                //     setPhase2Details({
                                //       ...phase2Details,
                                //       payoutCallbackUrl: e.target.value,
                                //     })
                                //   }
                                // />
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.payoutCallbackUrl}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Chargeback Callback URL",
                              value: isPhase2Editing ? (
                                <div className="form-group">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control p-3 text-center"
                                      value={
                                        phase2Details.chargebackCallbackUrl
                                      }
                                      onChange={(e) =>
                                        setPhase2Details({
                                          ...phase2Details,
                                          chargebackCallbackUrl: e.target.value,
                                        })
                                      }
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      id="verifyButton"
                                      onClick={() =>
                                        handleVerifyUrl(
                                          phase2Details.chargebackCallbackUrl,
                                          "chargeback"
                                        )
                                      }
                                    >
                                      Verify
                                    </button>
                                  </div>
                                  <div className="d-flex justify-content-start">
                                    {chargebackCallbackStatus ? (
                                      <span
                                        id="callBackUrlErr"
                                        className="text-success"
                                      >
                                        <VerifiedIcon className="fs-4" />{" "}
                                        Verified
                                      </span>
                                    ) : (
                                      <span
                                        id="callBackUrlErr"
                                        className="text-danger"
                                      >
                                        <NewReleasesIcon className="fs-4" /> Not
                                        Verified
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                // <input
                                //   type="text"
                                //   className="form-control p-3 text-center mb-2"
                                //   value={phase2Details.chargebackCallbackUrl}
                                //   onChange={(e) =>
                                //     setPhase2Details({
                                //       ...phase2Details,
                                //       chargebackCallbackUrl: e.target.value,
                                //     })
                                //   }
                                // />
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.chargebackCallbackUrl}
                                  disabled
                                />
                              ),
                            },

                            // Other rows...
                          ].map((item, index) => (
                            <tr key={index} className="col-6">
                              <div className="d-flex justify-content-between">
                                <strong className=" mt-4 form-label">
                                  {item.label}
                                </strong>
                                <div className="col-6 border-none">
                                  {item.value}
                                </div>
                              </div>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-6 ">
                    <div className="table-sm right-border">
                      <table className="table">
                        <thead>
                          <div className="fw-bold fs-4 border-bottom d-flex justify-content-between">
                            <div>Label</div>
                            <div>Value</div>
                          </div>
                        </thead>
                        <tbody>
                          {[
                            {
                              label: "Merchant Account Number",
                              value: isPhase2Editing ? (
                                <input
                                  type="number"
                                  className="form-control p-3 text-center mb-2"
                                  value={phase2Details.merchantAccountNumber}
                                  onChange={(e) =>
                                    setPhase2Details({
                                      ...phase2Details,
                                      merchantAccountNumber: e.target.value,
                                    })
                                  }
                                />
                              ) : (
                                <input
                                  type="number"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.merchantAccountNumber}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Merchant Bank Name",
                              value: isPhase2Editing ? (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={phase2Details.merchantBankName}
                                  onKeyDown={(e) => {
                                    setPressedKeyName(getKeyPressed(e));
                                  }}
                                  onChange={(e) =>
                                    checkPhase2Validation("merchantBankName", e)
                                  }
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.merchantBankName}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Merchant IFSC Code",
                              value: isPhase2Editing ? (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={phase2Details.merchantIfscCode}
                                  onKeyDown={(e) => {
                                    if (e.key === " ") {
                                      e.preventDefault();
                                    }
                                  }}
                                  name="merchantIfscCode"
                                  onChange={(e) =>
                                    setPhase2Details({
                                      ...phase2Details,
                                      merchantIfscCode: e.target.value,
                                    })
                                  }
                                  onBlur={handelValidations}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.merchantIfscCode}
                                  disabled
                                />
                              ),
                            },
                            {
                              label: "Website URL",
                              value: isPhase2Editing ? (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={phase2Details.websiteUrl}
                                  name="websiteUrl"
                                  onChange={(e) =>
                                    setPhase2Details({
                                      ...phase2Details,
                                      websiteUrl: e.target.value,
                                    })
                                  }
                                  onBlur={handelValidations}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control p-3 text-center mb-2"
                                  value={merchantData.websiteUrl}
                                  disabled
                                />
                              ),
                            },
                            // Other rows...
                          ].map((item, index) => (
                            <tr key={index} className="col-6">
                              <div className="d-flex justify-content-between">
                                <strong className=" mt-4 form-label">
                                  {item.label}
                                </strong>
                                <div className="col-6 border-none">
                                  {item.value}
                                </div>
                              </div>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div id="" className="form-wizard order-create">
              <div id="" className="tab-pane" role="tabpanel">
                <div className="row">
                  {isPhase2Editing && (
                    <div className="row">
                      {/* <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Account Beneficiary Name
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.accoutBeneficiaryName}
                              onKeyDown={(e) => {
                                setPressedKeyName(getKeyPressed(e));
                              }}
                              onChange={(e) =>
                                checkPhase2Validation(
                                  "accoutBeneficiaryName",
                                  e
                                )
                              }
                            />
                          ) : (
                            merchantData.accoutBeneficiaryName
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Bank Branch Name
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.bankBranchName}
                              onKeyDown={(e) => {
                                setPressedKeyName(getKeyPressed(e));
                              }}
                              onChange={(e) =>
                                checkPhase2Validation("bankBranchName", e)
                              }
                            />
                          ) : (
                            merchantData.bankBranchName
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Payin Callback URL
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.callBackUrl}
                              onChange={(e) =>
                                setPhase2Details({
                                  ...phase2Details,
                                  callBackUrl: e.target.value,
                                })
                              }
                            />
                          ) : (
                            merchantData.callBackUrl
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Payout Callback URL
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.payoutCallbackUrl}
                              onChange={(e) =>
                                setPhase2Details({
                                  ...phase2Details,
                                  payoutCallbackUrl: e.target.value,
                                })
                              }
                            />
                          ) : (
                            merchantData.payoutCallbackUrl
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Chargeback Callback URL
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.chargebackCallbackUrl}
                              onChange={(e) =>
                                setPhase2Details({
                                  ...phase2Details,
                                  chargebackCallbackUrl: e.target.value,
                                })
                              }
                            />
                          ) : (
                            merchantData.chargebackCallbackUrl
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Merchant Account Number
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="number"
                              className="form-control p-3"
                              value={phase2Details.merchantAccountNumber}
                              onChange={(e) =>
                                setPhase2Details({
                                  ...phase2Details,
                                  merchantAccountNumber: e.target.value,
                                })
                              }
                            />
                          ) : (
                            merchantData.merchantAccountNumber
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Merchant Bank Name
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.merchantBankName}
                              onKeyDown={(e) => {
                                setPressedKeyName(getKeyPressed(e));
                              }}
                              onChange={(e) =>
                                checkPhase2Validation("merchantBankName", e)
                              }
                            />
                          ) : (
                            merchantData.merchantBankName
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Merchant IFSC Code
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.merchantIfscCode}
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault();
                                }
                              }}
                              name="merchantIfscCode"
                              onChange={(e) =>
                                setPhase2Details({
                                  ...phase2Details,
                                  merchantIfscCode: e.target.value,
                                })
                              }
                              onBlur={handelValidations}
                            />
                          ) : (
                            merchantData.merchantIfscCode
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                          <label className="mb-1 text-dark fs-4">
                            Website URL
                          </label>
                          {isPhase2Editing ? (
                            <input
                              type="text"
                              className="form-control p-3"
                              value={phase2Details.websiteUrl}
                              name="websiteUrl"
                              onChange={(e) =>
                                setPhase2Details({
                                  ...phase2Details,
                                  websiteUrl: e.target.value,
                                })
                              }
                              onBlur={handelValidations}
                            />
                          ) : (
                            merchantData.websiteUrl
                          )}
                        </div>
                      </div> */}
                    </div>
                  )}
                  {hasMerchantEdit ? (
                    <div className="d-flex flex-end gap-2">
                      {isEditing && !isPhase2Editing ? (
                        <button
                          className="badge badge-rounded badge-success mx-3 px-3 py-2"
                          onClick={handleSave}
                        >
                          Update
                        </button>
                      ) : (
                        hasMerchantEdit && (
                          <button
                            className="badge badge-rounded badge-primary mx-3 px-3 py-2"
                            onClick={
                              merchantData.applicationStatus === null
                                ? ShowAlert
                                : toggleEditing
                            }
                          >
                            Edit Phase 1
                          </button>
                        )
                      )}

                      {isPhase2Editing ? (
                        <button
                          className="badge badge-rounded badge-success mx-3 px-3 py-2"
                          onClick={handlePhase2Save}
                        >
                          Update
                        </button>
                      ) : (
                        hasMerchantEdit && (
                          <button
                            className="badge badge-rounded badge-primary mx-3 px-3 py-2"
                            onClick={
                              merchantData.applicationStatus === null
                                ? ShowAlert
                                : togglePhase2Editing
                            }
                          >
                            Edit Phase 2
                          </button>
                        )
                      )}
                    </div>
                  ) : null}
                  <div className="d-flex justify-content-end ">
                    <button
                      type="button"
                      class="badge badge-rounded badge-info mx-4 px-4 py-2 mb-25"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}

export default OpenDetails;
